import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TablePagination,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import React, { useContext, useEffect, useState } from 'react';
import axios, { AxiosResponse, isAxiosError } from 'axios';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { ClearIcon } from '@mui/x-date-pickers';
import VerifiedIcon from '@mui/icons-material/Verified';
import EditIcon from '@mui/icons-material/Edit';
import PreviewIcon from '@mui/icons-material/Preview';
import { emptyDriver } from '../../drivers/driver-forms/driver-form.utils';
import {
  ActorFilterOption,
  DeliveryStateFilterOption,
  IFilterOption,
  PaymentStateFilterOption,
} from '../../../common/filter-bar/types';
import { DoubleDate } from '../../../common/double-date-picker/double-date-picker.interfaces';
import { PaginationContext } from '../../../../contexts/pagination-context';
import { buildQueryParams } from '../../../common/filter-bar/filter-bar.utils';
import GenericTable from '../../../common/generic-table/generic-table';
import { displayMoney } from '../../../../utils/money';
import ConfirmAction from '../../../common/confirm-action/confirm-action';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

import RestorePageIcon from '@mui/icons-material/RestorePage';
import CreatePaymentTask from '../../../common/create-payment-task/create-payment-task';
import InvoicePDFDialog from '../../../common/invoice-pdf-dialog/invoice-pdf-dialog';
import StorefrontIcon from '@mui/icons-material/Storefront';
import DoubleDatePicker from '../../../common/double-date-picker/double-date-picker';
import FilterBar from '../../../common/filter-bar/filter-bar';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import CreateNewInvoice, { Target } from './create-new-orders-invoice';
import EditingInvoice from './editing-invoice';
import { IDriverInvoice } from '../../../../interfaces/common/driver-invoices';
import { OrderType } from '../../../../interfaces/delivery-company/orders';
import { DriverType } from '../../../../interfaces/delivery-company/drivers';
import AutocompleteWithThrottle from '../../../common/autocomplete-with-throttle/autocomplete-with-throttle';
import { DeliveryState, PaymentState } from '../../../../enums/orders';
import { showDriverInvoiceState } from '../../../../utils/driver-invoices';
import { MerchantType } from '../../../../interfaces/delivery-company/merchants';
import {
  IMerchantOrdersInvoice,
  MerchantOrdersInvoiceState,
} from '../../../../interfaces/common/merchant-invoices';
import {
  canCancelMerchantInvoice,
  showMerchantInvoiceState,
} from '../../../../utils/merchant-invoices';
import {
  defaultMerchantFooter,
  defaultMerchantReportFieldsConfig,
} from '../../../common/report-builder/fields-config';
import { color } from 'framer-motion';
import { ReportProps } from '../../../common/report-builder/report';
import { OrgSettingsContext } from '../../../../contexts/org-settings-context';
import { CANCELLED } from 'dns';
import { emptyTotalAmounts } from '../../../../interfaces/common/invoice';
import { ErrorsFlattenner } from '../../../common/errors-flattenner/errors-flattenner';
import ResponsiveMerchantInvoicesListing from '../../common/merchant-invoices-listing';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import { useSearchParams } from 'react-router-dom';
import MerchantsBalance from './merchants_balance';
import { useSnackBar } from '../../../../contexts/snackbar';
import { format } from 'date-fns';
import { DataResources, GlobalPermissions, ResourceActionType, user_has_data_model_access, user_has_global_permission } from '../../../../utils/permissions';
import { useApiConfigWithBranch } from '../../../../hooks/use-api-config-with-branch';

export function MerchantOrdersAccounting() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [showingBalances, setShowingBalances] = useState(false);
  const {showMessage} = useSnackBar()

  const merchantID = searchParams.get('merchantID');
  const merchantName = searchParams.get('merchantName');
  const merchantPhone = searchParams.get('merchantPhone');
  const handleChange = (merchant: MerchantType | null) => {
    const newParams: any = merchant
      ? {
          merchantID: merchant.id,
          merchantName: merchant.name,
          merchantPhone: merchant.phone_number,
        }
      : {};
    updateParams({ ...newParams, target: 'merchant' });
  };
  useEffect(()=>updateParams({
    target: 'merchant',
  }), [])

  const updateParams = (newParams: Record<string, string>) => {
    const updated = new URLSearchParams(searchParams.toString());
  
      Object.entries(newParams).forEach(([key, value]) => {
        updated.set(key, value);
      });
  
      setSearchParams(updated);
    };
  
    useEffect(()=>updateParams({target: 'driver'}),[])
  

  const [merchant, setMerchant] = useState<MerchantType | null>(() => {
    return merchantID && merchantName && merchantPhone
      ? ({
          id: merchantID,
          name: merchantName,
          phone_number: merchantPhone,
        } as MerchantType)
      : null;
  });
  const [filters, setFilters] = useState<IFilterOption[]>([]);
  const [invoicesList, setInvoicesList] = useState<IMerchantOrdersInvoice[]>(
    []
  );
  const [invoicesCount, setInvoicesCount] = useState<number>(0);
  const [dateFilter, setDateFilter] = useState<DoubleDate>({
    startDate: null,
    endDate: null,
  });
  const { color } = useContext(OrgSettingsContext);
  const [message, setMessage] = useState<string>('');
  const [response, setResponse] = useState<AxiosResponse>();
  const [isLoading, setIsLoading] = useState(false);
  const [lockedInvoiceMeta, setLockedInvoiceMeta] =
    useState<IMerchantOrdersInvoice | null>(null);
  const [lockType, setLockType] = useState<'view' | 'delete' | null>(null);
  const [confirmUndoInvoice, setConfirmUndoInvoice] =
    useState<IMerchantOrdersInvoice | null>(null);
  const [creatingNewInvoice, setCreatingNewInvoice] = useState<boolean>(false);

  const [pdfData, setPdfData] = useState<ArrayBuffer | null>(null);
  const [legacyPdfData, setLegacyPdfData] = useState<IMerchantOrdersInvoice | null>(null);
  const [editingInvoice, setEditingInvoice] =
    useState<IMerchantOrdersInvoice | null>(null);

  const handleEditNote = async (invoice_pk: string) => {
    const note = prompt('Enter new note');
    if (note === null) {
      return;
    }

    const endpoint = `${API_ENDPOINT}/api/v1/merchant-invoice/${invoice_pk}/`;

    try {
      const response = await axios.patch(endpoint, { notes: [note] }, config);
      const clonedRows: IMerchantOrdersInvoice[] = invoicesList.map(
        (invoice) =>
          invoice.id == invoice_pk
            ? { ...invoice, notes: [...invoice.notes, note] }
            : invoice
      );
      setInvoicesList(clonedRows);
      setResponse(response);
    } catch (e) {
      if (isAxiosError(e)) {
        setResponse(e.response);
        setMessage('Failed to modify invoice note: ' + e.response?.statusText);
      } else {
        setMessage('Failed to modify invoice note');
      }
    }
  };

  const { user } = useContext(AuthContext);
  const { config, branchKey } = useApiConfigWithBranch();

  const { paginationConfig, setPaginationConfig } =
    useContext(PaginationContext);
  const [paginationController, setPaginationController] = useState({
    page: 0,
    rowsPerPage: paginationConfig.rowsPerPage,
  });

  const createInvoice = async (targets: Target[], extraCharges?: any[], paymentMethod?: any) => {
    if (merchant == null) {
      throw new Error('no merchant was chosen');
    }
    
    if (!paymentMethod) {
      throw new Error('Payment method is required');
    }
    
    const orders = targets.map((target) => target as OrderType);
    const payload = {
      merchant: merchant.id,
      orders_keys: orders.map((order) => order.id),
      extra_charges: extraCharges || [],
      payment_method: paymentMethod,
    };
    
    console.log('Creating invoice with payload:', payload);
    
    return await axios.post(
      `${API_ENDPOINT}/api/v1/merchant-invoices/`,
      payload,
      config
    );
  };

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setPaginationController({
      ...paginationController,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setPaginationConfig({ ...paginationConfig, rowsPerPage: newRowsPerPage });
    setPaginationController({
      ...paginationController,
      rowsPerPage: newRowsPerPage,
      page: 0,
    });
  };

  const resetPaginationController = () => {
    setPaginationController({
      ...paginationController,
      page: 0,
    });
  };

  const dateFilterAction = (dateFilterValue: DoubleDate) => {
    resetPaginationController();
    setDateFilter(dateFilterValue);
  };

   const fetchInvoices = async () => {
     if (!user_has_data_model_access(user, DataResources.MERCHANT_INVOICE, ResourceActionType.VIEW)) return
      setIsLoading(true);
      let response: any;
      const relevant_fields = [
        'id',
        'net_due_to_merchant',
        'merchant',
        'packages',
        'created_at',
        'status',
        'notes',
        'payment_method'
      ];
      let endpoint = `${API_ENDPOINT}/api/v1/merchant-invoices/?page=${paginationController.page + 1}&page_size=${paginationController.rowsPerPage}&fields=${relevant_fields.join(',')}`;

      const { startDate, endDate } = dateFilter;

      if (startDate !== null) {
        endpoint += `&date_from=${encodeURIComponent(startDate.format('YYYY-MM-DD'))}`;
      }

      if (endDate !== null) {
        endpoint += `&date_to=${encodeURIComponent(endDate.format('YYYY-MM-DD'))}`;
      }

      const filterQueryParams = buildQueryParams(filters);
      endpoint += `${filterQueryParams}`;

      if (merchant) {
        endpoint += `&merchant=${merchant.id}`;
      }

      try {
        response = await axios.get<{
          count: number;
          results: IMerchantOrdersInvoice[];
        }>(endpoint, config);
        console.log(response.data);

        setResponse(response);
        setInvoicesList(response.data.results);
        setInvoicesCount(response.data.count);
      } catch (e) {
        if (axios.isAxiosError(e)) {
          console.log('error: ', e);
          setResponse(e.response);
          setMessage('Failed to fetch invoices: ' + e.response?.statusText);
        } else {
          setMessage('Failed to fetch invoices');
        }
        console.log(e);
      }

      setIsLoading(false);
    };
    
  useEffect(() => {
    
   
    fetchInvoices();
  }, [dateFilter, paginationController, filters, merchant, branchKey]);

  const legacyFetchInvoiceContent = async (invoicemeta: IMerchantOrdersInvoice) => {
    setLockedInvoiceMeta(invoicemeta);
    setLockType('view');

    const endpoint = `${API_ENDPOINT}/api/v1/merchant-invoice/${invoicemeta.id}/`;

    try {
      const response = await axios.get(endpoint, config);
      setResponse(response);
      console.log('target = ', response);
      const data: IMerchantOrdersInvoice = response.data;
      setLegacyPdfData(data);
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage(
          'Failed to download invoice content: ' + e.response?.statusText
        );
      } else {
        setMessage('Failed to download invoice content');
      }
    }
    setLockedInvoiceMeta(null);
    setLockType(null);
  };


  const fetchInvoiceContent = async (invoicemeta: IMerchantOrdersInvoice) => {
    setLockedInvoiceMeta(invoicemeta);
    setLockType('view');

    const endpoint = `${API_ENDPOINT}/api/v1/merchant-invoice/${invoicemeta.id}/print/`;

    try {
      const response: AxiosResponse<ArrayBuffer> = await axios.get(endpoint, {responseType: 'arraybuffer', ...config});
      setResponse(response);
  
      const blob = new Blob([response.data], { type: "application/pdf" });

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      const formattedDate = format(
        invoicemeta.created_at,
        'dd-MM-yyyy'
      );
      
      link.download = `${invoicemeta.id}.${invoicemeta.merchant?.name ?? 'merchant'}.${formattedDate}.pdf`;
      link.click();

  URL.revokeObjectURL(url); 
      setPdfData(response.data);
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage(
          'Failed to download invoice content: ' + e.response?.statusText
        );
      } else {
        setMessage('Failed to download invoice content');
      }
    }
    setLockedInvoiceMeta(null);
    setLockType(null);
  }

  const filterQueryAction = (filters: IFilterOption[]) => {
    resetPaginationController();
    setFilters(filters);
  };

  const handleUndoInvoice = async (invoicemeta: IMerchantOrdersInvoice) => {
    setMessage('');
    setResponse(undefined);

    try {
      const reason = prompt(
        'Please indicate why you are cancelling this invoice'
      );
      if (!reason || reason.length == 0) {
        alert('Unable to undo invoice without providing a reason.');
        return;
      }

      const endpoint = `${API_ENDPOINT}/api/v1/merchant-invoice/${invoicemeta.id}/?reason=${reason}`;
      await axios.delete(endpoint, config);

      setInvoicesList(
        invoicesList.map((invoice) =>
          invoice.id !== invoicemeta.id
            ? invoice
            : {
                ...invoice,
                status: MerchantOrdersInvoiceState.CANCELLED,
                orders: [],
                packages: 0,
                total_amounts: emptyTotalAmounts,
              }
        )
      );
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage('Failed to undo invoice: ' + e.response?.statusText);
      } else {
        setMessage('Failed to undo invoice');
      }
    }

    setLockType(null);
    setLockedInvoiceMeta(null);
  };

  const handleFetchMerchants = async (
    query: string
  ): Promise<MerchantType[]> => {
    const endpoint = `${API_ENDPOINT}/api/v1/merchants/?page_size=10&name_or_phone=${encodeURIComponent(query)}`;

    try {
      const response = await axios.get<{
        count: number;
        results: MerchantType[];
      }>(endpoint, config);
      return response.data.results;
    } catch (error) {
      console.log(error);
    }

    return [];
  };

  return (
    <div className="content-container">
      <Box>
        {message !== '' && (
          <>
            <Alert
              severity={
                response && response.status >= 200 && response.status < 300
                  ? 'success'
                  : 'error'
              }
            >
              <>
                {message}

                {response && response.status >= 300 && (
                  <ErrorsFlattenner rawErrors={response.data} />
                )}
              </>
            </Alert>

            <br />
          </>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Button
            onClick={() => setShowingBalances(true)}
            variant="contained"
            color="warning"
            disabled={!user_has_global_permission(user, GlobalPermissions.ACCESS_SHOP_BALANCE)}
          >
            Shops Balances
          </Button>

          <Button
            disabled={merchant == null}
            variant="contained"
            size={(isMobile && !isTablet) ? 'small' : 'large'}
            onClick={() => setCreatingNewInvoice(true)}
          >
            Generate New Invoice
          </Button>
        </div>
        <br />

        <AutocompleteWithThrottle
          label={'Select Merchant'}
          required={false}
          fetch={handleFetchMerchants}
          value={merchant}
          getOptionLabel={(option: MerchantType) =>
            option.name + ' ' + option.phone_number
          }
          onChange={(e, value) => {
            setMerchant(value);
            handleChange(value);
          }}
        />
        <br />
        {!user_has_data_model_access(user, DataResources.MERCHANT_INVOICE, ResourceActionType.VIEW) ? 
              <Alert severity='warning'>You do not have permission to view invoices.</Alert> : 
            <><Accordion elevation={0}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography
                  variant="h5"
                  component="h5"
                  sx={{ textAlign: 'center', mt: 1, mb: 1 }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                    }}
                  >
                    <ManageSearchIcon fontSize="large" color="primary" />
                    <span>
                      <b>Search and Filter Controls</b>
                    </span>
                  </div>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DoubleDatePicker dateFilterAction={dateFilterAction} />
                <br />
                <FilterBar
                  filterQueryAction={filterQueryAction}
                  currentlySelectedFilters={filters}
                  filterKeys={['merchant invoice status', 'payment method']}
                />
              </AccordionDetails>
            </Accordion>

            <ResponsiveMerchantInvoicesListing
              invoicesList={invoicesList}
              isLoading={isLoading}
              setLockedInvoiceMeta={setLockedInvoiceMeta}
              setLockType={setLockType}
              setConfirmUndoInvoice={setConfirmUndoInvoice}
              setEditingInvoice={setEditingInvoice}
              handleEditNote={handleEditNote}
              fetchInvoiceContent={fetchInvoiceContent}
              legacyFetchInvoiceContent={legacyFetchInvoiceContent}
              lockedInvoiceMeta={lockedInvoiceMeta}
              lockType={lockType}
            />

            <TablePagination
              component="div"
              onPageChange={handlePageChange}
              page={paginationController.page}
              count={invoicesCount}
              rowsPerPage={paginationController.rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 250, 500, 1000]}
              labelRowsPerPage=""
              style={{ overflow: 'visible' }}
            /></>
                  }
      </Box>


      {merchant != null && (
        <CustomDialog
          open={creatingNewInvoice}
          fullWidth
          maxWidth="xl"
          fullScreen={(isMobile && !isTablet)}
          onClose={() => {
            setCreatingNewInvoice(false);
          }}
        >
          <div
            style={{
              textAlign: 'right',
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <IconButton
              onClick={() => {
                setCreatingNewInvoice(false);
              }}
            >
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

          <DialogContent sx={{ overflow: 'visible', minHeight: 400 }}>
            <CreateNewInvoice
              mode={'delivery'}
              merchant={merchant}
              fixed_filters_query={`payable_to_merchant=true&merchant=${merchant.id}`}
              onSuccess={()=>{
                // show message
                showMessage("Invoice created successfully")
                // refetch invoices
                fetchInvoices()

                // close dialog
                setCreatingNewInvoice(false);
              }}
              filter_keys={[
                'customer',
                'driver',
                'district',
                'governorate',
                'workflow',
              ]}
              create_invoice_callback={createInvoice}
            />
          </DialogContent>
        </CustomDialog>
      )}

      <CustomDialog
        open={editingInvoice != null}
        fullWidth
        maxWidth="xl"
        fullScreen={(isMobile && !isTablet)}
        onClose={() => {
          setEditingInvoice(null);
        }}
      >
        <div
          style={{
            textAlign: 'right',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <IconButton
            onClick={() => {
              setEditingInvoice(null);
            }}
          >
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
        </div>

        <DialogContent sx={{ overflow: 'visible', minHeight: 400 }}>
          {editingInvoice != null && (
            <EditingInvoice
              invoice={editingInvoice}
              updateInvoice={(invoice) =>
                setInvoicesList(
                  invoicesList.map((item) =>
                    item.id == invoice.id ? invoice : item
                  )
                )
              }
            />
          )}
        </DialogContent>
      </CustomDialog>

      {confirmUndoInvoice && (
        <ConfirmAction
          message={'Are you sure you want to undo this invoice?'}
          action={() => handleUndoInvoice(confirmUndoInvoice)}
          isOpen={true}
          handleClose={() => {
            setConfirmUndoInvoice(null);
            setLockType(null);
            setLockedInvoiceMeta(null);
          }}
          isSevereAction={true}
          confirmSevereActionTarget="undo invoice"
        >
          <div>
            Attention: This action will change the payment state of the orders
            included in the invoice
          </div>
        </ConfirmAction>
      )}

      {showingBalances && (
        <MerchantsBalance
          onClose={() => setShowingBalances(false)}
          title={'Merchants Balance'}
        />
      )}

{legacyPdfData && legacyPdfData.merchant && (
              <InvoicePDFDialog
                pdfData={legacyPdfData}
                onClose={() => setLegacyPdfData(null)}
                merchant={legacyPdfData.merchant}
              />
            )}
    </div>
  );
}

export default MerchantOrdersAccounting;
